import React, { useState, useEffect } from 'react';
import {FormGroup, FormControlLabel, Checkbox, Card, CardContent, Typography, Button, List, ListItem, ListItemText, Collapse, Fab} from '@material-ui/core';
import {ExpandLess, ExpandMore, Remove, Add} from '@material-ui/icons';
import _ from 'lodash';
import {BASENAME} from "../../../constants";
import { trackPromise} from 'react-promise-tracker';
import CourseInput from './CourseInput';

const AssociateOutcomes = (props) => {
    const [courseList, setCourseList] = useState([]);
    const [outcomeList, setOutcomeList] = useState([]);
    const [outcomesForAllList, setOutcomesForAllList] = useState([]);
    const [selectAllCourses, setSelectAllCourses] = useState(false);
    const [selectAllOutcomes, setSelectAllOutcomes] = useState(false);
    const [prevProps, setPrevProps] = useState(props);

    useEffect(() => {
        if(prevProps.requiredCourses!=props.requiredCourses){
            populateCoursesAndOutcomes();
            setPrevProps(props);
        }else if(props.requiredCourses.length>0){
            populateCoursesAndOutcomes();
        }
    }, [prevProps,props]);

    const populateCoursesAndOutcomes = () =>{
        const updatedCourses = props.requiredCourses.map(course=>{
            let existingCourseOutcomes = [];
            const linkedProgramOutcomes = course.outcomes?.find(outcome=>outcome.program_id==props.selectedProgram.id);
            if(linkedProgramOutcomes){
                const filteredProgramOutcomes = props.programOutcomes.filter(pOutcome=>linkedProgramOutcomes.outcome_ids.some(cOutcome=>cOutcome==pOutcome.id));
                filteredProgramOutcomes.forEach(outcome=>{
                    existingCourseOutcomes.push({
                        outcomeId:outcome.id,
                        outcomeName:outcome.name,
                        // programId:props.selectedProgram.pid,
                        selected:true
                    })
                })
            }
            return{
                programId:props.selectedProgram.pid,
                courseName:`${course.code} - ${course.title}`,
                courseId:course.id,
                relatedOutcomes:existingCourseOutcomes,
                isRelatedOutcomesDisplayed:false
            } 
        })
        const updatedOutcomes = props.programOutcomes.map(outcome=>{
            return{
                outcomeName:outcome.name,
                outcomeId:outcome.id,
                // programId:props.selectedProgram.pid
            }
        })
        setCourseList(updatedCourses);
        setOutcomeList(updatedOutcomes);
    }

    const handleSelectAllCourses = () =>{
        let updatedCourseList = courseList.map((course)=>({
            ...course,
            selected:!selectAllCourses
        }));
        setCourseList(updatedCourseList);
        setSelectAllCourses(!selectAllCourses);
    }

    //function to handle matching related outcomes on the course object to outcomesList on new course select
    const updateOutcomesListForSelectedCourse = (courseId) =>{
        const selectedCourse = courseList.filter(course=>course.courseId == courseId);
        const updatedOutcomeList = outcomeList.map(outcome=>{
            if(selectedCourse[0].relatedOutcomes.some(ro=>ro.outcomeId==outcome.outcomeId)){
                return{
                    ...outcome,
                    selected:true
                }
            }
            else{
                return{
                    ...outcome,
                    selected:false
                }
            }
        })
        setOutcomeList(updatedOutcomeList);
    }

    const handleCourseSelect = (courseId) =>{
        const updatedCourseList = courseList.map((course)=>{
            if(course.courseId==courseId){
                return{
                    ...course,
                    selected: selectAllCourses?course.selected:!course.selected,
                    isRelatedOutcomesDisplayed: !course.isRelatedOutcomesDisplayed
                }
            }else{
                return{
                    ...course,
                    selected:false,
                    isRelatedOutcomesDisplayed: false
                }
            }
        });
        setCourseList(updatedCourseList);
        setSelectAllCourses(false);
        setSelectAllOutcomes(false);
        updateOutcomesListForSelectedCourse(courseId);
    }

    const renderCollapseIcon = (course) =>{
        // const selectedRelatedOutcomes = course.relatedOutcomes.filter(ro=>ro.selected);
        if(course.relatedOutcomes?.length>0){
            if(course.isRelatedOutcomesDisplayed){
                return(
                    <ExpandLess />
                )
            }else{
                return(
                    <ExpandMore />
                )
            }
        }else{
            return<></>
        }
    }

    const renderRelatedOutcomes = (course) =>{
        if(course.relatedOutcomes.length>0){
            return course.relatedOutcomes.map(ro=>{
                return(
                    <div>
                        <Fab style={{ transform: 'scale(0.7)' }} size="small" color="secondary" aria-label="remove">
                            <Remove onClick={()=>handleOutcomeSelect('',ro.outcomeId)}/>
                        </Fab>
                        {ro.outcomeName}
                    </div>
                ) 
            })
        }    
    }

    const renderCourses = () =>{
        return (
            <div>
              <FormGroup>
                <FormControlLabel control={<Checkbox checked={selectAllCourses} onChange={() => handleSelectAllCourses()} />} label="Select All Courses" />
              </FormGroup>
              <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #ccc', paddingRight: '8px' }}>
                {courseList.map((course) => (
                  <div key={course.courseId} className={course.selected ? 'mapSelectedCourse' : ''}>
                    <ListItem dense button onClick={() => handleCourseSelect(course.courseId)} style={{ display: 'flex' }}>
                      <ListItemText primary={course.courseName} />
                      {renderCollapseIcon(course)}
                    </ListItem>
                    <Collapse in={course.isRelatedOutcomesDisplayed} timeout="auto" unmountOnExit>
                      <List component="li" disablePadding>
                        {renderRelatedOutcomes(course)}
                      </List>
                    </Collapse>
                  </div>
                ))}
              </div>
            </div>
          );
          
    };

    const handleOutcomeSelect = (action, outcomeId) => {
        let updatedOutcomeList = outcomeList.map(outcome => {
            if (action === 'addAll') {
                return { ...outcome, selected: !selectAllOutcomes };
            }
            if (outcome.outcomeId === outcomeId) {
                return { ...outcome, selected: !outcome.selected };
            }
            return outcome;
        });
    
        if (action === 'addAll') {
            setSelectAllOutcomes(!selectAllOutcomes);
        } else {
            setSelectAllOutcomes(false);
        }
    
        const selectedOutcomes = updatedOutcomeList.filter(outcome => outcome.selected);
        
        const updateRelatedOutcomes = (course) => {
            let updatedRelatedOutcomes;
            if (action === 'addAll') {
                updatedRelatedOutcomes = selectAllOutcomes ? [] : outcomeList.map(outcome => ({ ...outcome, selected: true }));
                setOutcomesForAllList(updatedRelatedOutcomes);
            } else {
                const existingOutcome = outcomesForAllList.find(outcome => outcome.outcomeId === outcomeId);
                const matchingProgramOutcome = outcomeList.find(outcome => outcome.outcomeId === outcomeId);
                updatedRelatedOutcomes = existingOutcome
                    ? outcomesForAllList.filter(outcome => outcome.outcomeId !== outcomeId)
                    : [...outcomesForAllList, matchingProgramOutcome];
                setOutcomesForAllList(updatedRelatedOutcomes);
            }
            return updatedRelatedOutcomes;
        };
    
        let updatedCourseList = courseList.map(course => {
            if (course.selected) {
                if (selectAllCourses) {
                    return { ...course, relatedOutcomes: updateRelatedOutcomes(course) };
                } else {
                    return { ...course, relatedOutcomes: [...selectedOutcomes] };
                }
            }
            return course;
        });
    
        setCourseList(updatedCourseList);
        setOutcomeList(updatedOutcomeList);
    };
    
    // const handleOutcomeSelect = (action, outcomeId) =>{
        
    //     let updatedOutcomeList;
    //     if(action=='addAll'){
    //         updatedOutcomeList = outcomeList.map(outcome=>{
    //             return{
    //                 ...outcome,
    //                 selected:!selectAllOutcomes
    //             }
    //         });
    //         setSelectAllOutcomes(!selectAllOutcomes)
    //     }else{
    //         //todo - the outcome list needs to match the related outcomes for the selected course
    //         updatedOutcomeList = outcomeList.map(outcome=>{
    //             if(outcome.outcomeId==outcomeId){
    //                 return{
    //                     ...outcome,
    //                     selected: !outcome.selected
    //                 }
    //             }
    //             return outcome;
    //         });
    //     setSelectAllOutcomes(false);
    //     }
    //     const selectedOutcomes = updatedOutcomeList.filter(outcome=>outcome.selected);
    //     //todo - add outcomes that are part of the course that don't exist on the selected program outcome level
        
    //     let updatedCourseList;
    //     //logic for selecting the outcomes that apply to all courses - need to update outcomesForAllList and relatedOutcomes on a course
    //     if(selectAllCourses){
    //         updatedCourseList = courseList.map(course=>{
    //             if(course.selected){
    //                 let updatedRelatedOutcomes;
    //                 if(action=='addAll'){
    //                     //remove all outcomes from all courses
    //                     if(selectAllOutcomes){
    //                         updatedRelatedOutcomes=[]
    //                         setOutcomesForAllList(updatedRelatedOutcomes);
    //                     }
    //                     //add all outcomes to all courses
    //                     else{
    //                         updatedRelatedOutcomes=outcomeList.map(outcome=>{
    //                             return{
    //                                 ...outcome,
    //                                 selected:true
    //                             }
    //                         })
    //                         setOutcomesForAllList(updatedRelatedOutcomes);
    //                     }
    //                 }else{
    //                     //add/remove outcome from all courses
    //                     const existingOutcome = outcomesForAllList.filter(outcome=>outcome.outcomeId == outcomeId);
    //                     const matchingProgramOutcome = outcomeList.filter(outcome=>outcome.outcomeId == outcomeId);
    //                     if(existingOutcome.length>0){
    //                         updatedRelatedOutcomes = outcomesForAllList.filter(outcome=>outcome.outcomeId!=existingOutcome[0].outcomeId);
    //                     }else{
    //                         updatedRelatedOutcomes = [...outcomesForAllList,...matchingProgramOutcome];
    //                     }
    //                     setOutcomesForAllList(updatedRelatedOutcomes);
    //                 }

    //                 return{
    //                     ...course,
    //                     relatedOutcomes:updatedRelatedOutcomes
    //                 }
    //             }
    //         })
    //     }else{
    //         //add/remove outcome to selected course
    //         updatedCourseList = courseList.map(course=>{
    //             if(course.selected){
    //                 return{
    //                     ...course,
    //                     relatedOutcomes:[...selectedOutcomes]
    //                 }
    //             }
    //             return course;
    //         })
    //     }
    //     setCourseList(updatedCourseList);
    //     setOutcomeList(updatedOutcomeList);
    // }

    const renderOutcomesList = () =>{
        let addedOutcomeIds = [];
        if(selectAllCourses){
            //setting the outcomes to match those selected for all courses
            addedOutcomeIds = outcomesForAllList.map(outcome=>{return outcome.outcomeId});
        }else{
            addedOutcomeIds = courseList.filter(course=>course.selected).flatMap(course=>course.relatedOutcomes.map(ro=>{
                const outcomeFound = ro.linkedOutcomes?.filter(lo=>props.programOutcomes?.some(po=>po.id==lo.outcomeId));
                if(ro.selected&&outcomeFound?.length>0){
                    return outcomeFound[0].outcomeId;
                }else if(ro.selected && outcomeFound == undefined){
                    return ro.outcomeId;
                }else{
                    return null
                }
            }));
        }
        const selectedCourse = courseList.filter(course=>course.selected);
        const isCourseSelected = selectedCourse.length>0?true:false;
        return(
            <div>
                {isCourseSelected?
                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={selectAllOutcomes} onChange={()=>handleOutcomeSelect('addAll', '')} />} label="Add all outcomes to selected course" />
                </FormGroup>
                :<span></span>}
                    {outcomeList.map((outcome)=>(
                    <div key={outcome.outcomeId} className = {addedOutcomeIds.includes(outcome.outcomeId)?'mapSelectedCourse':''}>
                        <ListItem dense button>
                            {isCourseSelected?<div>
                                {addedOutcomeIds.includes(outcome.outcomeId)?
                                    <Fab style={{ transform: 'scale(0.6)' }} size="small" color="secondary" aria-label="Add">
                                        <Remove onClick={()=>handleOutcomeSelect('', outcome.outcomeId)}/>
                                    </Fab>:
                                    <Fab style={{ transform: 'scale(0.6)' }} size="small" color="secondary" aria-label="Add">
                                        <Add onClick={()=>handleOutcomeSelect('', outcome.outcomeId)}/>
                                    </Fab>
                                }
                            </div>:
                            <div></div>
                            } 
                            <ListItemText primary={outcome.outcomeName} />
                        </ListItem>         
                    </div>
                ))}
            </div>
        )
    }

    //check for courses where the outcomes were added/removed - this is to avoid a put on a course where the outcomes aren't changed
    // const changedCourses = () =>{
    //     const courseListCopy = JSON.parse(JSON.stringify(courseList));
    //     courseListCopy.forEach(course=>{
    //         course.relatedOutcomes.forEach(outcome=>{
    //             outcome.value = outcome.outcomeName;
    //             outcome.id = outcome.outcomeId;
    //             delete outcome.outcomeName;
    //             delete outcome.outcomeId;
    //             delete outcome.selected;
    //         })
    //         course.outcomes = course.relatedOutcomes;
    //         delete course.relatedOutcomes;
    //     })
    //     //if course outcomes haven't changed, don't send to the backend
    //     const newCourseList = courseListCopy.map(course=>{
    //         const matchingCourse = props.requiredCourses.find(propCourse=>propCourse.id==course.courseId);
    //         function arraysMatch(array1, array2) {
    //             if (array1.length !== array2.length||array1==undefined||array2==undefined) {
    //                 return false;
    //             }
            
    //             // Deep comparison function for objects
    //             const deepCompare = (obj1, obj2) => _.isEqual(obj1, obj2);
            
    //             // Sort arrays by stringified objects to compare them regardless of order
    //             const sortedArray1 = _.sortBy(array1, 'id');
    //             const sortedArray2 = _.sortBy(array2, 'id');
            
    //             // Compare each element of the sorted arrays
    //             return sortedArray1.every((item, index) => deepCompare(item, sortedArray2[index]));
    //         }
    //         if(!arraysMatch(matchingCourse.outcomes, course.outcomes)){
    //             return course
    //         }else{return null}
    //     })
    //     const filteredCourseList = newCourseList.filter(course=>course!=null);
    //     return filteredCourseList
    // }

    const handleAddCourse = (addedCourse) =>{
        console.log('courseAdd', courseList)
        console.log('added course', addedCourse);
        if(addedCourse){
            const newCourse = {
                courseId:addedCourse.courseId,
                courseName:addedCourse.courseName,
                isRelatedOutcomesDisplayed:false,
                programId:props.selectedProgram.id,
                relatedOutcomes:[]
            }
    
    
            setCourseList(prevCourseList => [
                ...courseList,
                newCourse
            ]);
        }
    }

    const handleSubmit = async() =>{
        // const changedCourseOutcomes = changedCourses();
        // console.log('handle submit ', changedCourseOutcomes);
        // const courseListToUpdate = courseList.filter(course=>changedCourseOutcomes.some(changedCourse=>changedCourse.courseId==course.courseId));
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/outcomes/associate',{
                method:'POST',
                headers:{
                    'Content-Type':'application/json'
                },
                body:JSON.stringify({courses:courseList})
            }));

            if(res.ok){
                // Reset courseList and outcomeList after successful submission
                setCourseList(prevCourseList => prevCourseList.map(course => ({
                    ...course,
                    selected: false,
                    isRelatedOutcomesDisplayed: false, 
                })));
                setOutcomeList(prevOutcomeList => prevOutcomeList.map(outcome => ({
                    ...outcome,
                    selected: false
                })));
                setSelectAllCourses(false);
                setSelectAllOutcomes(false);
            }else{
                throw Error('No Response from the back-end')
            }
        } catch (err) {
            console.log('Error submitting associations for course', err);
        }
    }

    return(
        <>
        <div className='row'>
            <div className='columnLeft' style={{width: '40%'}}>
                {outcomeList.length>0&&
                    <Card>
                        <CardContent>
                        {courseList.length>0&&
                                <div>
                                    <Typography variant="h4" gutterBottom>
                                        Courses
                                    </Typography>
                                    {renderCourses()}
                                </div>      
                            }
                            <h3>Add Course from Course Dog</h3>
                            <CourseInput handleAddCourse={handleAddCourse}></CourseInput>
                        </CardContent>
                    </Card>
                }
                
            </div>


            
            {outcomeList.length>0&&
                <div style={{width:'60%'}}>
                <div className='columnRight'>
                    <Card>
                        <CardContent>
                            <Typography variant="h4" gutterBottom>
                                Program Outcomes
                            </Typography>
                            {renderOutcomesList()}
                        </CardContent>
                    </Card>
                </div>
                <div>
                    <Button variant="contained" color="secondary" style={{float:'right', marginTop:'15px'}} onClick={handleSubmit}>
                        Associate Outcomes
                    </Button>
                </div>
                </div>
            }
        </div>
        
        </>
    )
};

export default AssociateOutcomes;
